import { compose, lifecycle, withHandlers } from 'recompose';
import moment from 'moment';
import { connect } from 'react-redux';
import withDefaultEndingDate from '../filters/containers/withDefaultEndingDate';
import { getEndDate, getStartDate } from '../filters/selectors';
import { selectEndDate, selectStartDate } from '../actions';
import withTimezone from '../../../auth/utils/withTimezone';

const mapStateToProps = state => ({
  startDate: getStartDate(state),
  endDate: getEndDate(state),
});

const mapDispatchToProps = {
  selectStartDate,
  selectEndDate,
};

export default compose(
    withTimezone,
    connect(mapStateToProps, mapDispatchToProps),
    withHandlers({
      onDateChange: props => (start, end) => {
        props.selectStartDate(start);
        props.selectEndDate(end);
      },
    }),
    lifecycle({
      componentDidMount() {
        const isInitialized = this.props.startDate !== null || this.props.endDate !== null;
        if (!isInitialized) {
          const startDate = moment().tz(this.props.timezone).toDate();
          const endDate = moment().tz(this.props.timezone).toDate();
          this.props.onDateChange(startDate, endDate);
        }
      },
    }),
    withDefaultEndingDate(),
);
